/* unplugin-vue-components disabled */import script from "./ConfirmOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmOrder.vue?vue&type=style&index=0&id=6b03dc80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b03dc80"]])

export default __exports__